// extracted by mini-css-extract-plugin
export default {"card":"Services_card__UOAYH"};